module.exports = __webpack_public_path__ + "static/media/trains-icon-blue.4eadd16b.PNG";